export default __webpack_public_path__ + "static/media/button-AR-On.85004a36.png";